module.exports = __webpack_public_path__ + "img/10.77e368ef.png";